<template>
	<field v-bind="{error, name, tooltip, required, test, group}">
		<component :is="comp" v-bind="[props, {value, sectionId, fieldComp: sectionField}]" @update="update"/>
	</field>
</template>

<script>
import {get} from "lodash";
import sectionField from "./field.vue";
import field from "@/components/order/fields/index.vue";

export default {
	components: {field},
	props: {
		props: {type: Object, required: true},
		test: {type: Object, required: false},
		name: {type: String, required: false},
		tooltip: {type: Object, required: false},
		sectionId: {type: String, required: true},
		required: {type: Boolean, required: false}
	},
	data() {
		return {
			sectionField,
			tooltipActive: false
		}
	},
	computed: {
		group: (t) => t.props.type === "group",
		value: (t) => get(t.$store.getters["order/data"], [t.sectionId, t.name]),
		error: (t) => (t.required ? !t.value : false) || (t.test ? !t.test.func(t.value) : false),
		comp: (t) => () => import(/* webpackMode: "eager" */ `@/components/order/fields/${t.props.type}.vue`)
	},
	methods: {
		update(value) {
			this.$store.commit("order/field", {sectionId: this.sectionId, fieldName: this.name, value});
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
